// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"h3-z","vrsnlCrossSiteLabel":"i3-z"};